import { FC, PropsWithChildren, useContext, useState } from 'react';
import { StrategyAutomationsContext } from './contexts';

// This provider is used to store the strategy id for which the automations modal is opened
// to ensure that only one modal is opened at a time
const StrategyAutomationsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [
    strategyCardRandomIdForOpenedAutomations,
    setStrategyCardRandomIdForOpenedAutomations,
  ] = useState<number | null>(null);

  return (
    <StrategyAutomationsContext.Provider
      value={{
        strategyCardRandomIdForOpenedAutomations,
        setStrategyCardRandomIdForOpenedAutomations,
      }}
    >
      {children}
    </StrategyAutomationsContext.Provider>
  );
};

export default StrategyAutomationsProvider;

export function useStrategyAutomations() {
  const context = useContext(StrategyAutomationsContext);
  if (context === undefined) {
    throw new Error(
      `useStrategyAutomations must be used within a StrategyAutomationsProvider`,
    );
  }

  return context;
}
